import React from 'react';
import { GlobalStyles } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * GlobalResponsiveStyles - Applies global styles to enhance responsive behavior
 * throughout the application
 */
const GlobalResponsiveStyles: React.FC = () => {
  const theme = useTheme();
  
  return (
    <GlobalStyles
      styles={{
        // Responsive font sizes for headings
        h1: {
          fontSize: '2.5rem !important',
          [theme.breakpoints.down('md')]: {
            fontSize: '2rem !important',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.75rem !important',
          },
        },
        h2: {
          fontSize: '2rem !important',
          [theme.breakpoints.down('md')]: {
            fontSize: '1.75rem !important',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.5rem !important',
          },
        },
        h3: {
          fontSize: '1.75rem !important',
          [theme.breakpoints.down('md')]: {
            fontSize: '1.5rem !important',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.35rem !important',
          },
        },
        h4: {
          fontSize: '1.5rem !important',
          [theme.breakpoints.down('md')]: {
            fontSize: '1.35rem !important',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.25rem !important',
          },
        },
        
        // Improve touch targets for mobile
        'button, a': {
          [theme.breakpoints.down('sm')]: {
            minHeight: '44px',
            minWidth: '44px',
          },
        },
        
        // Make sure images are responsive
        'img': {
          maxWidth: '100%',
          height: 'auto',
        },
        
        // Ensure proper spacing in form fields on mobile
        '.MuiFormControl-root': {
          [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
          },
        },
        
        // Improve table responsiveness
        '.MuiTable-root': {
          [theme.breakpoints.down('md')]: {
            display: 'block',
            width: '100%',
            overflowX: 'auto',
          },
        },
        
        // Ensure proper padding on containers
        '.MuiContainer-root': {
          [theme.breakpoints.down('sm')]: {
            padding: '0 16px',
          },
        },
        
        // Ensure proper spacing between sections
        '.section-spacing': {
          marginBottom: '80px',
          [theme.breakpoints.down('md')]: {
            marginBottom: '60px',
          },
          [theme.breakpoints.down('sm')]: {
            marginBottom: '40px',
          },
        },
        
        // Improved responsive flex layouts
        '.responsive-flex': {
          display: 'flex',
          flexWrap: 'wrap',
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
          },
        },
        
        // Better spacing between items in a responsive grid
        '.responsive-grid': {
          display: 'grid',
          gridGap: '24px',
          [theme.breakpoints.down('md')]: {
            gridGap: '16px',
          },
        },
        
        // Prevent overflow issues on mobile
        'body': {
          overflowX: 'hidden',
        },
        
        // Ensure smooth scrolling
        'html': {
          scrollBehavior: 'smooth',
        },
        
        // Ensure elements don't get too small on mobile
        '.min-touch-target': {
          minHeight: '44px',
          minWidth: '44px',
        },
        
        // Responsive text alignment classes
        '.text-center-xs': {
          [theme.breakpoints.down('sm')]: {
            textAlign: 'center !important',
          },
        },
        '.text-left-xs': {
          [theme.breakpoints.down('sm')]: {
            textAlign: 'left !important',
          },
        },
        '.text-right-xs': {
          [theme.breakpoints.down('sm')]: {
            textAlign: 'right !important',
          },
        },
        
        // Better spacing for mobile devices
        '.mobile-padding': {
          [theme.breakpoints.down('sm')]: {
            padding: '16px !important',
          },
        },
        '.mobile-margin': {
          [theme.breakpoints.down('sm')]: {
            margin: '16px !important',
          },
        },
      }}
    />
  );
};

export default GlobalResponsiveStyles; 